import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">Страна КВН</h1>
          <p className="header-subtitle">Мониторинг развития команд КВН в регионах России</p>
        </div>

        <div className="header-right">
          <div className="header-logos">
            <a
              href="https://guu.ru"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
              title="Государственный университет управления"
            >
              <img
                src="https://www.kop.ru/upload/iblock/def/def58357b27a197608e3bce3bd5aee01.png"
                alt="ГУУ"
                className="header-logo"
              />
            </a>
            <a
              href="https://minobrnauki.gov.ru"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
              title="Министерство науки и высшего образования РФ"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/New_Emblem_of_the_Ministry_of_science_and_higher_education_of_the_Russian_Federation.svg/2560px-New_Emblem_of_the_Ministry_of_science_and_higher_education_of_the_Russian_Federation.svg.png"
                alt="Минобрнауки"
                className="header-logo"
              />
            </a>
            <a
              href="https://kvn.ru"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
              title="КВН"
            >
              <img
                src="https://kvn.ru/public/images/front/logo.png"
                alt="КВН"
                className="header-logo header-logo-kvn"
              />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;